export default function DeclarationSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-8 text-center">
        <span className="text-xs font-medium text-primary-500 uppercase tracking-widest">
          实时爆料 · 全网追踪
        </span>
        <p className="mt-6 text-xl md:text-2xl text-foreground-800 leading-relaxed">
          全网最新热点黑料、网红翻车现场、明星不为人知的秘密，一条不落，尽收眼底 <span role="img" aria-label="西瓜">🍉</span>
        </p>
      </div>
    </section>
  );
}